var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.75C3.86192 15.75 3.75 15.8619 3.75 16V22H2.25V16C2.25 15.0335 3.03352 14.25 4 14.25H8C8.96648 14.25 9.75 15.0335 9.75 16V22H8.25V16C8.25 15.8619 8.13808 15.75 8 15.75H4Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.75C15.8619 17.75 15.75 17.8619 15.75 18V22H14.25V18C14.25 17.0335 15.0335 16.25 16 16.25H20C20.9665 16.25 21.75 17.0335 21.75 18V22H20.25V18C20.25 17.8619 20.1381 17.75 20 17.75H16Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.75C9.86192 13.75 9.75 13.8619 9.75 14V22H8.25V14C8.25 13.0335 9.03352 12.25 10 12.25H14C14.9665 12.25 15.75 13.0335 15.75 14V22H14.25V14C14.25 13.8619 14.1381 13.75 14 13.75H10Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C12.2855 1.25 12.5462 1.41207 12.6726 1.66807L13.8258 4.00479L16.5826 4.31029C16.879 4.34314 17.1278 4.54846 17.2163 4.83324C17.3047 5.11802 17.2161 5.42816 16.9905 5.62316L14.9858 7.35581L15.5148 9.84403C15.5753 10.1282 15.4661 10.4218 15.2346 10.5975C15.0031 10.7731 14.691 10.7992 14.4336 10.6646L12 9.39143L9.56655 10.6645C9.30909 10.7992 8.99698 10.7731 8.76551 10.5975C8.53404 10.4218 8.42485 10.1283 8.48528 9.84404L9.01426 7.35582L7.00959 5.62316C6.78398 5.42815 6.69533 5.11802 6.78379 4.83324C6.87226 4.54845 7.12103 4.34314 7.41743 4.31029L10.1743 4.00479L11.3275 1.66809C11.4538 1.41209 11.7145 1.25 12 1.25ZM12.0001 3.69471L11.3377 5.0369C11.2245 5.26635 11.0021 5.42225 10.7477 5.45043L9.29047 5.61191L10.3305 6.5108C10.5373 6.68959 10.6305 6.96676 10.5736 7.23419L10.2841 8.59629L11.6524 7.88044C11.8701 7.76651 12.1299 7.76651 12.3477 7.88044L13.716 8.59629L13.4264 7.2342C13.3696 6.96677 13.4627 6.68959 13.6696 6.5108L14.7096 5.61191L13.2524 5.45043C12.9981 5.42224 12.7757 5.26636 12.6625 5.03692L12.0001 3.69471Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRank);
export default __webpack_public_path__ + "static/media/ic-rank.0f31001ee87e44ad4e9301a9c43e1bd5.svg";
export { ForwardRef as ReactComponent };